import { useCallback, useMemo, useState } from 'react';

/** Multi-select state for tables and grids, kept as a Set of ids. */
export default function useSelection(items = []) {
  const [selected, setSelected] = useState(() => new Set());

  const toggle = useCallback((id) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }, []);

  const clear = useCallback(() => setSelected(new Set()), []);

  const selectAll = useCallback(() => {
    setSelected(new Set(items.map((i) => i.id)));
  }, [items]);

  const toggleAll = useCallback(() => {
    setSelected((prev) => (prev.size === items.length && items.length > 0 ? new Set() : new Set(items.map((i) => i.id))));
  }, [items]);

  const selectedItems = useMemo(() => items.filter((i) => selected.has(i.id)), [items, selected]);

  return {
    selected,
    selectedItems,
    count: selected.size,
    isSelected: (id) => selected.has(id),
    allSelected: items.length > 0 && selected.size === items.length,
    someSelected: selected.size > 0 && selected.size < items.length,
    toggle,
    toggleAll,
    selectAll,
    clear,
  };
}
